import React from 'react'
import Header from '../inc/Header'
import Ourstore from './Ourstore'
import { Link } from "react-router-dom";

function Storepage() {
  return (
    <div>
      <Header />
      <br />
      <br />
      <br />
      <br />
      <br/>

      <div className='newback'>
        <div className="album py-1">

          <div className="container mt-3">

            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Our Store Page</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <br />
      <Ourstore />
    </div>
  )
}

export default Storepage